import React from "react";

// Type Imports
import { IPortfolioMetadata } from "@pulse-ui/codegen/generated_ts/org_metadata";

// Material UI Imports
import { Avatar, AvatarGroup, Fade, Tooltip } from "@mui/material";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";

const UserPortfoliosCell: React.FC<{
  portfolios: string[];
  roles: string[];
  portfolios_context_data: IPortfolioMetadata[];
}> = React.memo(({ portfolios, roles, portfolios_context_data }) => {
  const isAdmin = roles && roles.includes("admin");

  const portfolio_display_names = portfolios
    .map((portfolio: string) => {
      return portfolios_context_data.find(
        (portfolio_metadata) => portfolio_metadata.portfolio_id === portfolio
      )?.display_name;
    })
    .filter((display_name) => display_name !== undefined);

  const tooltipTitle = isAdmin
    ? "All Active Portfolios"
    : portfolio_display_names.length > 0
    ? portfolio_display_names.length > 5
      ? `${portfolio_display_names.slice(0, 5).join(", ")}...`
      : portfolio_display_names.join(", ")
    : "No Active Portfolios";

  return (
    <Tooltip
      title={tooltipTitle}
      arrow
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#cbdcf9",
            color: "#091229",
            fontWeight: "bold",
          },
        },

        arrow: {
          sx: {
            color: "#cbdcf9",
          },
        },

        transition: { timeout: 600 }
      }}
      slots={{
        transition: Fade
      }}>
      <AvatarGroup
        max={2}
        sx={{
          "& .MuiAvatarGroup-avatar": {
            backgroundColor: "#091229",
            borderColor: "#cbdcf9 !important",
            color: "#cbdcf9",
            height: "2rem",
            width: "2rem",
          },
        }}
      >
        {portfolio_display_names.length > 0 && !isAdmin ? (
          portfolio_display_names.map((portfolio: any) => {
            return (
              <Avatar
                key={portfolio}
                alt={portfolio}
                sx={{
                  backgroundColor: "#091229",
                  borderColor: "#cbdcf9 !important",
                  height: "2rem",
                  width: "2rem",
                }}
              >
                <SwitchAccountIcon className="pulse-color--tertiary-100" />
              </Avatar>
            );
          })
        ) : (
          <Avatar
            alt={isAdmin ? "All Portfolios" : "No Portfolios"}
            sx={{
              backgroundColor: "#091229",
              height: "2rem",
              width: "2rem",
            }}
          >
            <SwitchAccountIcon
              className={
                isAdmin
                  ? "pulse-color--background-100"
                  : "pulse-color--background-300"
              }
            />
          </Avatar>
        )}
      </AvatarGroup>
    </Tooltip>
  );
});

export default UserPortfoliosCell;
